import type { Content } from "@prismicio/client";
import { asText } from "@prismicio/helpers";
import { useMemo } from "react";
import { useCountdown, resolveLabels, buildParts } from "../useCountdown";

type Props = {
  slice: Content.CountdownTimerSliceWovarBrand;
};

const WovarBrandTimer = ({ slice }: Props) => {
  const title = asText(slice.primary.title);
  const timeLeft = useCountdown(slice.primary.target_date);

  const labels = useMemo(
    () => resolveLabels(slice.primary),
    [slice.primary],
  );

  const parts = buildParts(timeLeft, labels);

  return (
    <>
      <div className="ct-brand__display">
        {title && (
          <h2 className="ct-brand__title">
            {title.split(/(\*[^*]+\*)/g).map((segment, i) =>
              segment.startsWith("*") && segment.endsWith("*") ? (
                <span key={i} className="ct-brand__accent">
                  {segment.slice(1, -1)}
                </span>
              ) : (
                segment
              ),
            )}
          </h2>
        )}

        <div className="ct-brand__countdown">
          {parts.map((part) => (
            <div key={part.key} className="ct-brand__time-box">
              <div className="ct-brand__lcd">
                <span
                  className={`ct-brand__number${part.key === "seconds" ? " ct-brand__number--accent" : ""}`}
                  suppressHydrationWarning
                >
                  {part.value}
                </span>
              </div>
              {slice.primary.show_labels !== false && (
                <span className="ct-brand__label">{part.label}</span>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="ct-brand__tape-mechanism">
        <div className="ct-brand__tape-blade">
          <div
            className={`ct-brand__tape-ticks${timeLeft.completed ? " ct-brand__tape-ticks--stopped" : ""}`}
          />
        </div>
        <div className="ct-brand__tape-housing">
          <div
            className={`ct-brand__hex-nut${timeLeft.completed ? " ct-brand__hex-nut--stopped" : ""}`}
          />
        </div>
      </div>
    </>
  );
};

export default WovarBrandTimer;
